import React, { useEffect } from 'react';
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

import { GOOGLE_ANALYTICS_ID } from '../../utils/constants';

const UsePageViews = () => {
    let location = useLocation();

    ReactGA.initialize(GOOGLE_ANALYTICS_ID);

    useEffect(() => {
        ReactGA.send({ hitType: "pageview", page: location.pathname });
    }, [location]);
};

export default UsePageViews;
